// import React, { useEffect, useState } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { fetchCategories, deleteCategory, updateCategory } from '../../redux/slice/categoriesSlice';
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
//   IconButton, TextField, Button, CircularProgress
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
// import SaveIcon from '@mui/icons-material/Save';
// import CancelIcon from '@mui/icons-material/Cancel';
// import { AppDispatch } from '../../redux/storage/store';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { uploadImageToFirebase } from '../../libs/utils';

// const AdminCategoriesTable = () => {
//   const dispatch = useDispatch<AppDispatch>();
//   const { items: categories, loading } = useSelector((state: any) => state.categories);
//   const [editRow, setEditRow] = useState<string | null>(null);
//   const [formData, setFormData] = useState<{ name: string; image: string | File | null }>({ name: '', image: '' });
//   const [rowLoading, setRowLoading] = useState<string | null>(null);

//   useEffect(() => {
//     dispatch(fetchCategories());
//   }, [dispatch]);

//   const handleDelete = async (id: string) => {
//     setRowLoading(id);
//     try {
//       await dispatch(deleteCategory(id));
//       toast.success("Category deleted successfully");
//       dispatch(fetchCategories());
//     } catch (error) {
//       toast.error("Failed to delete category");
//     } finally {
//       setRowLoading(null);
//     }
//   };

//   const handleEditClick = (category: any) => {
//     setEditRow(category.id);
//     setFormData({ name: category.name, image: category.image });
//   };

//   const handleCancel = () => {
//     setEditRow(null);
//     setFormData({ name: '', image: '' });
//   };

//   const handleSave = async (id: string) => {
//     setRowLoading(id);
//     try {
//       let imageUrl = formData.image;

//       // Upload new image if it's a file
//       if (formData.image instanceof File) {
//         imageUrl = await uploadImageToFirebase(formData.image);
//       }

//       await dispatch(updateCategory({ id, data: { name: formData.name, image: imageUrl } }));
//       toast.success("Category updated successfully");
//       dispatch(fetchCategories());
//       setEditRow(null);
//     } catch (error) {
//       toast.error("Failed to update category");
//     } finally {
//       setRowLoading(null);
//     }
//   };

//   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (!e.target.files?.length) return;
//     const file = e.target.files[0];
//     if (!file.type.startsWith("image/")) {
//       toast.error("Selected file is not an image");
//       return;
//     }
//     setFormData(prev => ({ ...prev, image: file }));
//   };

//   return (
//     <TableContainer component={Paper}>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell>Category Name</TableCell>
//             <TableCell>Image</TableCell>
//             <TableCell>Actions</TableCell>
//             <TableCell>SL.No</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {loading ? (
//             <TableRow><TableCell colSpan={3}>Loading...</TableCell></TableRow>
//           ) : (
//             categories.map((category: any) => (
//               <TableRow key={category.id}>
//                 <TableCell>
//                   {editRow === category.id ? (
//                     <TextField
//                       value={formData.name}
//                       onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                       size="small"
//                     />
//                   ) : (
//                     category.name
//                   )}
//                 </TableCell>
//                 <TableCell>
//                   {editRow === category.id ? (
//                     <>
//                       <input
//                         type="file"
//                         accept="image/*"
//                         onChange={handleImageChange}
//                         style={{ marginBottom: 8 }}
//                       />
//                       <div>
//                         {formData.image && (
//                           <img
//                             src={
//                               formData.image instanceof File
//                                 ? URL.createObjectURL(formData.image)
//                                 : formData.image
//                             }
//                             alt="Preview"
//                             style={{ width: 80 }}
//                           />
//                         )}
//                       </div>
//                     </>
//                   ) : (
//                     <img src={category.image} alt={category.name} style={{ width: 80 }} />
//                   )}
//                 </TableCell>
//                 <TableCell>
//                   {editRow === category.id ? (
//                     <>
//                       <IconButton onClick={() => handleSave(category.id)} disabled={rowLoading === category.id}>
//                         {rowLoading === category.id ? <CircularProgress size={20} /> : <SaveIcon />}
//                       </IconButton>
//                       <IconButton onClick={handleCancel}><CancelIcon /></IconButton>
//                     </>
//                   ) : (
//                     <>
//                       <IconButton onClick={() => handleEditClick(category)}><EditIcon /></IconButton>
//                       <IconButton onClick={() => handleDelete(category.id)} disabled={rowLoading === category.id}>
//                         {rowLoading === category.id ? <CircularProgress size={20} /> : <DeleteIcon />}
//                       </IconButton>
//                     </>
//                   )}
//                 </TableCell>
//               </TableRow>
//             ))
//           )}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// export default AdminCategoriesTable;



import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCategories, deleteCategory, updateCategory } from '../../redux/slice/categoriesSlice';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  IconButton, TextField, CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { AppDispatch } from '../../redux/storage/store';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { uploadImageToFirebase } from '../../libs/utils';

const AdminCategoriesTable = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { items: categories, loading } = useSelector((state: any) => state.categories);
  const [editRow, setEditRow] = useState<string | null>(null);
  const [formData, setFormData] = useState<{ name: string; image: string | File | null; display_order: number }>({
    name: '',
    image: '',
    display_order: 0,
  });
  const [rowLoading, setRowLoading] = useState<string | null>(null);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  const handleDelete = async (id: string) => {
    setRowLoading(id);
    try {
      await dispatch(deleteCategory(id));
      toast.success("Category deleted successfully");
      dispatch(fetchCategories());
    } catch (error) {
      toast.error("Failed to delete category");
    } finally {
      setRowLoading(null);
    }
  };

  const handleEditClick = (category: any) => {
    setEditRow(category.id);
    setFormData({
      name: category.name,
      image: category.image,
      display_order: category.display_order || 0
    });
  };

  const handleCancel = () => {
    setEditRow(null);
    setFormData({ name: '', image: '', display_order: 0 });
  };

  const handleSave = async (id: string) => {
    setRowLoading(id);
    try {
      let imageUrl: string = '';

      if (formData.image instanceof File) {
        imageUrl = await uploadImageToFirebase(formData.image);
      } else if (typeof formData.image === 'string') {
        imageUrl = formData.image;
      }

      await dispatch(updateCategory({
        id,
        data: {
          name: formData.name,
          image: imageUrl,
          display_order: formData.display_order
        }
      }));

      toast.success("Category updated successfully");
      dispatch(fetchCategories());
      setEditRow(null);
    } catch (error) {
      toast.error("Failed to update category");
    } finally {
      setRowLoading(null);
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.length) return;
    const file = e.target.files[0];
    if (!file.type.startsWith("image/")) {
      toast.error("Selected file is not an image");
      return;
    }
    setFormData(prev => ({ ...prev, image: file }));
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Category Name</TableCell>
            <TableCell>Image</TableCell>
            <TableCell>Actions</TableCell>
            <TableCell>Display Order</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={4}>Loading...</TableCell>
            </TableRow>
          ) : (
            categories.map((category: any) => (
              <TableRow key={category.id}>
                <TableCell>
                  {editRow === category.id ? (
                    <TextField
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                      size="small"
                    />
                  ) : (
                    category.name
                  )}
                </TableCell>
                <TableCell>
                  {editRow === category.id ? (
                    <>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ marginBottom: 8 }}
                      />
                      <div>
                        {formData.image && (
                          <img
                            src={
                              formData.image instanceof File
                                ? URL.createObjectURL(formData.image)
                                : formData.image
                            }
                            alt="Preview"
                            style={{ width: 80 }}
                          />
                        )}
                      </div>
                    </>
                  ) : (
                    <img
                      src={category.image}
                      alt={category.name}
                      style={{ width: 80 }}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {editRow === category.id ? (
                    <>
                      <IconButton
                        onClick={() => handleSave(category.id)}
                        disabled={rowLoading === category.id}
                      >
                        {rowLoading === category.id ? (
                          <CircularProgress size={20} />
                        ) : (
                          <SaveIcon />
                        )}
                      </IconButton>
                      <IconButton onClick={handleCancel}>
                        <CancelIcon />
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <IconButton onClick={() => handleEditClick(category)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => handleDelete(category.id)}
                        disabled={rowLoading === category.id}
                      >
                        {rowLoading === category.id ? (
                          <CircularProgress size={20} />
                        ) : (
                          <DeleteIcon />
                        )}
                      </IconButton>
                    </>
                  )}
                </TableCell>
                <TableCell>
                  {editRow === category.id ? (
                    <TextField
                      type="number"
                      value={formData.display_order}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          display_order: Number(e.target.value)
                        })
                      }
                      size="small"
                      style={{ width: 80 }}
                    />
                  ) : (
                    category.display_order
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AdminCategoriesTable;

